export enum MessengerChannelAccessFields {
    LOGIN_USER = 'loginUser',
    TYPE = 'type',
    API_CONFIG = 'apiConfig',
    ADDRESS = 'address',
    PHONE_NUMBER_ID = 'phoneNumberId',
    PHONE_NUMBER = 'phoneNumber',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}
